/* istanbul ignore file */
import { Route, AppId, createPageRoute } from '@lumapps/router';

export const adminMobileConfigurationRoute: Route = createPageRoute({
    slug: 'mobile/app-configuration',
    appId: AppId.backOffice,
    id: 'mobile-configuration',
});
